// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2AdgW","alertIcon":"ConfirmModal_alertIcon__1MuSB"};